import styled from 'styled-components';

export default styled.a`
        text-decoration: none;
        color: ${props => props.theme.palette.secondary[700]};
        border-bottom: 1px solid transparent;
        
        &:focus,
        &:hover {
          border-bottom: 1px dashed  ${props => props.theme.palette.secondary[700]};
        }
        
        &:active {
          border-bottom: 1px solid ${props => props.theme.palette.secondary[500]};
          color: ${props => props.theme.palette.secondary[500]};
        }
        
        &:visited {
          border-bottom: 1px solid transparent;
          color: ${props => props.theme.palette.secondary[900]};
        }
    `;



// WEBPACK FOOTER //
// ./src/components/styles/StyledLink.js